import React from "react"
import { compose } from "recompose"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import Typography from "@material-ui/core/Typography"

const DialogsContainerDialog = ({
  fullScreen,
  classes,
  dispatch,
  open,
  data,
  handleClose,
  ...props
}) => {
  return (
    <Dialog
      className={classes.dialogsContainerDialog}
      fullScreen={fullScreen}
      open={Boolean(open)}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      PaperProps={{
        classes: {
          root: classes.dialogPaper
        }
      }}
    >
      <DialogContent className={classes.header} id="responsive-dialog-title">
        <Typography variant="h3" className={classes.headerTitle}>
          {props.title}
        </Typography>
        {props.subtitle && (
          <Typography className={classes.headerSubtitle}>
            {props.subtitle}
          </Typography>
        )}
      </DialogContent>
      <DialogContent className={classes.dialogContent}>
        {props.content}
      </DialogContent>
      {props.buttons && (
        <DialogActions className={classes.dialogActions}>
          {props.buttons}
        </DialogActions>
      )}
    </Dialog>
  )
}

export default compose(
  withStyles(styles),
  withMobileDialog()
)(DialogsContainerDialog)



// WEBPACK FOOTER //
// ./src/dialogs/DialogsContainer/index.jsx